import React from "react";

const BackChevronIcon = ({ darkMode }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10 3L5 8L10 13"
      stroke={darkMode ? "white" : "black"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CloseIcon = ({ darkMode }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 17 17"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M12.2996 4.1001L4.09961 12.3001M12.2996 12.3001L4.09961 4.1001"
      stroke={darkMode ? "white" : "black"}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const iconButtonClassName =
  "h-[30px] p-0 px-2 pt-1 bg-white hover:bg-slate-100 dark:bg-slate-950 dark:hover:bg-slate-800 cursor-pointer border-2 border-solid border-white hover:border-slate-100 dark:border-slate-950 dark:hover:border-slate-800 rounded-lg inline-flex items-center justify-center";

const SidePanelEditOverlay = (props) => (
  <div className="cf-automation-edit-overlay flex flex-col h-full bg-white dark:bg-slate-950 rounded-xl overflow-hidden">
    <div className="flex-shrink-0 px-5 pt-4 pb-3 border-0 border-b border-solid border-slate-200 dark:border-slate-800">
      <div className="flex items-center justify-between mb-3">
        <button
          type="button"
          title="Back"
          aria-label="Back"
          className={iconButtonClassName}
          onClick={props.onBack}
        >
          <BackChevronIcon darkMode={props.darkMode} />
        </button>
        <button
          type="button"
          title="Close"
          aria-label="Close"
          className={iconButtonClassName}
          onClick={props.onClose}
        >
          <CloseIcon darkMode={props.darkMode} />
        </button>
      </div>
      <h4 className="m-0 text-2xl font-bold text-black dark:text-white whitespace-nowrap text-ellipsis overflow-hidden">
        {props.title}
      </h4>
      <p className="mt-1 mb-0 text-lg text-slate-500 dark:text-slate-400">
        {props.subtitle}
      </p>
    </div>
    <div className="flex-1 min-h-0 overflow-y-auto px-5 py-6">
      {props.children}
    </div>
    <div className="flex-shrink-0 px-5 py-3 border-0 border-t border-solid border-slate-200 dark:border-slate-800">
      <button
        type="button"
        className="btn bg-white border-solid border-[1px] rounded-md !border-slate-200 text-black text-xl hover:bg-blue-100 hover:!border-blue-100 hover:text-blue-600"
        onClick={props.onBack}
      >
        Done
      </button>
    </div>
  </div>
);

export default SidePanelEditOverlay;
